module.exports = __webpack_public_path__ + "img/28800.9bcdcb64.jpg";